import { formatLocalizedDate, getDisplayLocale } from "@/lib/localized-date";

export const getOnboardingLocale = getDisplayLocale;
export const formatOnboardingDate = formatLocalizedDate;

export type OnboardingDueState = "upcoming" | "today" | "overdue" | null;

export function toOnboardingDateKey(value: string | Date | null | undefined): string | null {
  if (!value) return null;
  if (typeof value === "string") {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) return `${match[1]}-${match[2]}-${match[3]}`;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getOnboardingDueState(
  dueDate: string | Date | null | undefined,
  today: Date = new Date(),
): OnboardingDueState {
  const due = toOnboardingDateKey(dueDate);
  const current = toOnboardingDateKey(today);
  if (!due || !current) return null;
  if (due < current) return "overdue";
  if (due === current) return "today";
  return "upcoming";
}

export function getOnboardingRemainingDays(
  expectedEndDate: string | Date | null | undefined,
  today: Date = new Date(),
): number | null {
  const end = toOnboardingDateKey(expectedEndDate);
  const current = toOnboardingDateKey(today);
  if (!end || !current) return null;
  const toUtc = (key: string) => {
    const [year, month, day] = key.split("-").map(Number);
    return Date.UTC(year, month - 1, day);
  };
  return Math.max(0, Math.round((toUtc(end) - toUtc(current)) / 86_400_000));
}
